import { render, staticRenderFns } from "./DepartmentAdd.vue?vue&type=template&id=0a30d860&scoped=true"
import script from "./DepartmentAdd.vue?vue&type=script&lang=js"
export * from "./DepartmentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a30d860",
  null
  
)

export default component.exports